import dayjs from 'dayjs';
import type { ImageItem } from './types';

/** Primary timeline for ordering (matches grid date display). */
function primaryTimeMs(img: ImageItem): number {
  const c = dayjs(img.created_at);
  if (c.isValid()) return c.valueOf();
  const u = dayjs(img.uploaded_at);
  if (u.isValid()) return u.valueOf();
  return Number.NaN;
}

/** Secondary when primary timestamps tie (same calendar second, etc.). */
function secondaryTimeMs(img: ImageItem): number {
  const u = dayjs(img.uploaded_at);
  if (u.isValid()) return u.valueOf();
  return 0;
}

/**
 * Oldest → newest for compare (Dec → Feb → Mar).
 * Uses created_at, then uploaded_at, then stable name/id tie-breaks.
 */
export function sortImagesForCompareAscending(
  images: ImageItem[]
): ImageItem[] {
  return [...images].sort((a, b) => {
    const pa = primaryTimeMs(a);
    const pb = primaryTimeMs(b);
    const aOk = Number.isFinite(pa);
    const bOk = Number.isFinite(pb);
    if (aOk && bOk && pa !== pb) return pa - pb;
    if (aOk && !bOk) return -1;
    if (!aOk && bOk) return 1;

    const sa = secondaryTimeMs(a);
    const sb = secondaryTimeMs(b);
    if (sa !== sb) return sa - sb;

    const nameCmp = a.name.localeCompare(b.name, undefined, {
      sensitivity: 'base',
    });
    if (nameCmp !== 0) return nameCmp;
    return a.id - b.id;
  });
}
